import { render, staticRenderFns } from "./NormativaView.vue?vue&type=template&id=4895b79c&scoped=true"
import script from "./NormativaView.vue?vue&type=script&lang=js"
export * from "./NormativaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895b79c",
  null
  
)

export default component.exports